import {
    Button,
    FormControl,
    FormControlLabel,
    Grid,
    TextField
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateInput } from '../../../components/dateInput/DateInput';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import toast, { Toaster } from 'react-hot-toast';
import { getDateNow } from '../../../utils/convert';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';

import moment from 'moment';
import 'moment/locale/es';
import React, { useEffect, useState } from 'react';
import { TextInput } from '../../../components/textInput/TextInput';

const locale = "es-ES";
export const ModalidadModal = ({ open, onClose, dataFormModel, setDataFormModel, isNew, editRow }) => {

    const [radioSelected, setRadioSelected] = useState(1);

    const today = getDateNow();

    const initialModalidadBulto = {
        idProveedorMetodoCobroBulto: 0,
        idProveedorDistribuidor: 0,
        cantidad: 0,
        precio: 0,
        fechaDesde: null,
        fechaHasta: null
    };

    const editModalidadBulto = {
        idProveedorMetodoCobroBulto: editRow?.id,
        idProveedorDistribuidor: 0,
        cantidad: editRow?.cantidad,
        precio: editRow?.valor,
        fechaDesde: editRow?.fechaDesde,
        fechaHasta: editRow?.fechaHasta
    }

    const initialModalidadKilo = {
        idProveedorMetodoCobroKilo: 0,
        idProveedorDistribuidor: 0,
        valor: 0,
        valorExcedido: 0,
        pesoLimite: 0,
        fechaDesde: null,
        fechaHasta: null
    };

    const editModalidadKilo = {
        idProveedorMetodoCobroKilo: editRow?.id,
        idProveedorDistribuidor: 0,
        valor: editRow?.valor,
        valorExcedido: editRow?.pesoExcedido,
        pesoLimite: editRow?.pesoLimite,
        fechaDesde: editRow?.fechaDesde,
        fechaHasta: editRow?.fechaHasta
    };

    const initialModalidadKm = {
        idProveedorMetodoCobroKM: 0,
        idProveedorDistribuidor: 0,
        valor: 0,
        fechaDesde: null,
        fechaHasta: null
    };

    const editModalidadKm = {
        idProveedorMetodoCobroKM: editRow?.id,
        idProveedorDistribuidor: 0,
        valor: editRow?.valor,
        fechaDesde: editRow?.fechaDesde,
        fechaHasta: editRow?.fechaHasta
    };

    const [dataModalidadBulto, setDataModalidadBulto] = useState(isNew ? initialModalidadBulto : editModalidadBulto);
    const [dataModalidadKilo, setDataModalidadKilo] = useState(isNew ? initialModalidadKilo : editModalidadKilo);
    const [dataModalidadKm, setDataModalidadKm] = useState(isNew ? initialModalidadKm : editModalidadKm);

    useEffect(() => {
        if (!isNew) {
            switch (editRow.modalidad) {
                case 'Km': {
                    setRadioSelected(1);
                    setDataModalidadKm(editModalidadKm)
                    break;
                }
                case 'Bulto': {
                    setRadioSelected(2);
                    setDataModalidadBulto(editModalidadBulto)
                    break;
                }
                case 'Kilo': {
                    setRadioSelected(3);
                    setDataModalidadKilo(editModalidadKilo)
                    break;
                }
            }
        }
    }, [editRow])

    const handleChangeRadio = (e) => {
        setRadioSelected(parseInt(e.target.value));
    }

    const handleChangeKilo = (e) => {
        const { value, name } = e.target;

        setDataModalidadKilo(previousData => ({
            ...previousData,
            [name]: value
        }));
    }

    const handleChangeKM = (e) => {
        const { value, name } = e.target;

        setDataModalidadKm(previousData => ({
            ...previousData,
            [name]: value
        }));
    }

    const handleChangeBulto = (e) => {
        const { value, name } = e.target;

        setDataModalidadBulto(previousData => ({
            ...previousData,
            [name]: value
        }));
    }

    const handleChangeFechaDesdeBulto = (value) => {
        setDataModalidadBulto(previousData => ({
            ...previousData,
            fechaDesde: value
        }));
    }

    const handleChangeFechaHastaBulto = (value) => {
        setDataModalidadBulto(previousData => ({
            ...previousData,
            fechaHasta: value
        }));
    }

    const handleChangeFechaDesdeKilo = (value) => {
        setDataModalidadKilo(previousData => ({
            ...previousData,
            fechaDesde: value
        }));
    }

    const handleChangeFechaHastaKilo = (value) => {
        setDataModalidadKilo(previousData => ({
            ...previousData,
            fechaHasta: value
        }));
    }

    const handleChangeFechaDesdeKM = (value) => {
        setDataModalidadKm(previousData => ({
            ...previousData,
            fechaDesde: value
        }));
    }

    const handleChangeFechaHastaKM = (value) => {
        setDataModalidadKm(previousData => ({
            ...previousData,
            fechaHasta: value
        }));
    }

    const handleAdd = () => {
        switch (radioSelected) {
            case 1: {
                if (isValidItemKm()) {
                    addModalidadKm();
                    onClose();
                    cleanItemKm();
                }
                break;
            }
            case 2: {
                if (isValidItemBulto()) {
                    addModalidadBulto();
                    onClose();
                    cleanItemBulto();
                }
                break;
            }
            case 3: {
                if (isValidItemKilo()) {
                    addModalidadKilo();
                    onClose();
                    cleanItemKilo();
                }
                break;
            }
        }
    }

    const handleEdit = (row) => {
        switch (radioSelected) {
            case 1: {
                if (isValidItemKm()) {
                    editarModalidadKm();
                    onClose();
                    cleanItemKm();
                }
                break;
            }
            case 2: {
                if (isValidItemBulto()) {
                    editarModalidadBulto();
                    onClose();
                    cleanItemBulto();
                }
                break;
            }
            case 3: {
                if (isValidItemKilo()) {
                    editarModalidadKilo();
                    onClose();
                    cleanItemKilo();
                }
                break;
            }
        }
    }

    const handleCancelar = () => {
        cleanItemBulto();
        cleanItemKilo();
        cleanItemKm();
        setRadioSelected(1);
        onClose()
    }

    const addModalidadBulto = () => {
        const id = (-1) * dataFormModel?.rowsModalidades?.length - 1;
        let objeto = {
            idProveedorMetodoCobroBulto: id,
            idProveedorDistribuidor: dataModalidadBulto.idProveedorDistribuidor,
            cantidad: parseInt(dataModalidadBulto.cantidad),
            precio: parseFloat(dataModalidadBulto.precio),
            fechaDesde: moment(dataModalidadBulto.fechaDesde).format("yyyy-MM-DD"),
            fechaHasta: (dataModalidadBulto.fechaHasta) ? moment(dataModalidadBulto.fechaHasta).format("yyyy-MM-DD") : null
        };
        console.log(objeto)

        let objetoList = {
            id: id,
            modalidad: 'Bulto',
            fechaDesde: moment(dataModalidadBulto.fechaDesde).format("yyyy-MM-DD"),
            fechaHasta: (dataModalidadBulto.fechaHasta) ? moment(dataModalidadBulto.fechaHasta).format("yyyy-MM-DD") : null,
            cantidad: dataModalidadBulto.cantidad,
            pesoExcedido: '',
            pesoLimite: '',
            valor: dataModalidadBulto.precio,
        };

        setDataFormModel(previousData => ({
            ...previousData,
            modalidadBultos: [...previousData.modalidadBultos, objeto],
            rowsModalidades: [...previousData.rowsModalidades, objetoList]
        }));
    }

    const addModalidadKilo = () => {
        const id = (-1) * dataFormModel?.rowsModalidades?.length - 1;
        let objeto = {
            idProveedorMetodoCobroKilo: id,
            idProveedorDistribuidor: dataModalidadKilo.idProveedorDistribuidor,
            valor: parseFloat(dataModalidadKilo.valor),
            valorExcedido: parseFloat(dataModalidadKilo.valorExcedido),
            pesoLimite: parseFloat(dataModalidadKilo.pesoLimite),
            fechaDesde: moment(dataModalidadKilo.fechaDesde).format("yyyy-MM-DD"),
            fechaHasta: (dataModalidadKilo.fechaHasta) ? moment(dataModalidadKilo.fechaHasta).format("yyyy-MM-DD") : null
        };
        console.log(objeto)

        let objetoList = {
            id: id,
            modalidad: 'Kilo',
            fechaDesde: moment(dataModalidadKilo.fechaDesde).format("yyyy-MM-DD"),
            fechaHasta: (dataModalidadKilo.fechaHasta) ? moment(dataModalidadKilo.fechaHasta).format("yyyy-MM-DD") : null,
            cantidad: '',
            pesoExcedido: dataModalidadKilo.valorExcedido,
            pesoLimite: dataModalidadKilo.pesoLimite,
            valor: dataModalidadKilo.valor,
        };

        setDataFormModel(previousData => ({
            ...previousData,
            modalidadKilos:
                [...previousData.modalidadKilos, objeto],
            rowsModalidades: [...previousData.rowsModalidades, objetoList]
        }));
    }

    const addModalidadKm = () => {
        const id = (-1) * dataFormModel?.rowsModalidades?.length - 1;
        let objeto = {
            idProveedorMetodoCobroKM: id,
            idProveedorDistribuidor: dataModalidadKm.idProveedorDistribuidor,
            valor: parseInt(dataModalidadKm.valor),
            fechaDesde: moment(dataModalidadKm.fechaDesde).format("yyyy-MM-DD"),
            fechaHasta: (dataModalidadKm.fechaHasta) ? moment(dataModalidadKm.fechaHasta).format("yyyy-MM-DD") : null
        };
        console.log(objeto)

        let objetoList = {
            id: id,
            modalidad: 'Km',
            fechaDesde: moment(dataModalidadKm.fechaDesde).format("yyyy-MM-DD"),
            fechaHasta: (dataModalidadKm.fechaHasta) ? moment(dataModalidadKm.fechaHasta).format("yyyy-MM-DD") : null,
            cantidad: '',
            pesoExcedido: '',
            pesoLimite: '',
            valor: dataModalidadKm.valor,
        };

        setDataFormModel(previousData => ({
            ...previousData,
            modalidadKms:
                [...previousData.modalidadKms, objeto],
            rowsModalidades: [...previousData.rowsModalidades, objetoList]
        }));

        console.log(objetoList)
    }

    const editarModalidadKm = () => {
        const idProveedorMetodoCobroKM = (dataModalidadKm.idProveedorMetodoCobroKM > 0) ?
            dataModalidadKm.idProveedorMetodoCobroKM - 3000 :
            dataModalidadKm.idProveedorMetodoCobroKM;

        let objeto = {
            idProveedorMetodoCobroKM: idProveedorMetodoCobroKM,
            idProveedorDistribuidor: dataModalidadKm.idProveedorDistribuidor,
            valor: parseInt(dataModalidadKm.valor),
            fechaDesde: moment(dataModalidadKm.fechaDesde).format("yyyy-MM-DD"),
            fechaHasta: (dataModalidadKm.fechaHasta) ? moment(dataModalidadKm.fechaHasta).format("yyyy-MM-DD") : null
        }

        let objetoList = {
            id: dataModalidadKm.idProveedorMetodoCobroKM,
            modalidad: 'Km',
            fechaDesde: moment(dataModalidadKm.fechaDesde).format("yyyy-MM-DD"),
            fechaHasta: (dataModalidadKm.fechaHasta) ? moment(dataModalidadKm.fechaHasta).format("yyyy-MM-DD") : null,
            cantidad: '',
            pesoExcedido: '',
            pesoLimite: '',
            valor: dataModalidadKm.valor,
        };

        setDataFormModel(previousData => ({
            ...previousData,
            modalidadKms:
                [...(previousData?.modalidadKms || []).filter(x => x.idProveedorMetodoCobroKM !== idProveedorMetodoCobroKM), objeto],
            rowsModalidades: [...previousData.rowsModalidades.filter(x => x.id !== dataModalidadKm.idProveedorMetodoCobroKM), objetoList]
        }));
    }

    const editarModalidadBulto = () => {
        console.log('editarModalidadBulto')
        const idProveedorMetodoCobroBulto = (dataModalidadBulto.idProveedorMetodoCobroBulto > 0) ?
            dataModalidadBulto.idProveedorMetodoCobroBulto - 1000 :
            dataModalidadBulto.idProveedorMetodoCobroBulto;
        let objeto = {
            idProveedorMetodoCobroBulto: idProveedorMetodoCobroBulto,
            idProveedorDistribuidor: dataModalidadBulto.idProveedorDistribuidor,
            cantidad: parseInt(dataModalidadBulto.cantidad),
            precio: parseFloat(dataModalidadBulto.precio),
            fechaDesde: moment(dataModalidadBulto.fechaDesde).format("yyyy-MM-DD"),
            fechaHasta: (dataModalidadBulto.fechaHasta) ? moment(dataModalidadBulto.fechaHasta).format("yyyy-MM-DD") : null
        };

        let objetoList = {
            id: dataModalidadBulto.idProveedorMetodoCobroBulto,
            modalidad: 'Bulto',
            fechaDesde: moment(dataModalidadBulto.fechaDesde).format("yyyy-MM-DD"),
            fechaHasta: (dataModalidadBulto.fechaHasta) ? moment(dataModalidadBulto.fechaHasta).format("yyyy-MM-DD") : null,
            cantidad: dataModalidadBulto.cantidad,
            pesoExcedido: '',
            pesoLimite: '',
            valor: dataModalidadBulto.precio,
        };

        console.log(dataModalidadBulto)

        setDataFormModel(previousData => ({
            ...previousData,
            modalidadBultos:
                [...(previousData?.modalidadBultos || []).filter(x => x.idProveedorMetodoCobroBulto !== idProveedorMetodoCobroBulto), objeto],
            rowsModalidades: [...previousData.rowsModalidades.filter(x => x.id !== dataModalidadBulto.idProveedorMetodoCobroBulto), objetoList]
        }));
    }

    const editarModalidadKilo = () => {
        const idProveedorMetodoCobroKilo = (dataModalidadKilo.idProveedorMetodoCobroKilo > 0) ?
            dataModalidadKilo.idProveedorMetodoCobroKilo - 2000 :
            dataModalidadKilo.idProveedorMetodoCobroKilo;

        let objeto = {
            idProveedorMetodoCobroKilo: idProveedorMetodoCobroKilo,
            idProveedorDistribuidor: dataModalidadKilo.idProveedorDistribuidor,
            valor: parseFloat(dataModalidadKilo.valor),
            valorExcedido: parseFloat(dataModalidadKilo.valorExcedido),
            pesoLimite: parseFloat(dataModalidadKilo.pesoLimite),
            fechaDesde: moment(dataModalidadKilo.fechaDesde).format("yyyy-MM-DD"),
            fechaHasta: (dataModalidadKilo.fechaHasta) ? moment(dataModalidadKilo.fechaHasta).format("yyyy-MM-DD") : null
        };

        let objetoList = {
            id: dataModalidadKilo.idProveedorMetodoCobroKilo,
            modalidad: 'Kilo',
            fechaDesde: moment(dataModalidadKilo.fechaDesde).format("yyyy-MM-DD"),
            fechaHasta: (dataModalidadKilo.fechaHasta) ? moment(dataModalidadKilo.fechaHasta).format("yyyy-MM-DD") : null,
            cantidad: '',
            pesoExcedido: dataModalidadKilo.valorExcedido,
            pesoLimite: dataModalidadKilo.pesoLimite,
            valor: dataModalidadKilo.valor,
        };

        setDataFormModel(previousData => ({
            ...previousData,
            modalidadKilos:
                [...(previousData?.modalidadKilos || []).filter(x => x.idProveedorMetodoCobroKilo !== idProveedorMetodoCobroKilo), objeto],
            rowsModalidades: [...previousData.rowsModalidades.filter(x => x.id !== dataModalidadKilo.idProveedorMetodoCobroKilo), objetoList]
        }));
    }

    const cleanItemBulto = () => {
        setDataModalidadBulto(initialModalidadBulto);
        setRadioSelected(1)
    }

    const cleanItemKilo = () => {
        setDataModalidadKilo(initialModalidadKilo);
        setRadioSelected(1)
    }

    const cleanItemKm = () => {
        setDataModalidadKm(initialModalidadKm);
        setRadioSelected(1)
    }

    const isValidItemBulto = () => {
        if (dataModalidadBulto.cantidad <= 0) {
            toast.error('El campo Cantidad debe ser mayor a cero.');
            return false;
        }
        if (dataModalidadBulto.precio <= 0) {
            toast.error('El campo Importe debe ser mayor a cero.');
            return false;
        }
        if (dataModalidadBulto.fechaDesde === null) {
            toast.error('Debe ingresar el campo Fecha Desde.');
            return false;
        }
        if (dataFormModel?.rowsModalidades?.find(x => x.modalidad == 'Bulto' && x.id != dataModalidadBulto?.idProveedorMetodoCobroBulto && x.fechaDesde == moment(dataModalidadBulto?.fechaDesde).format("yyyy-MM-DD"))) {
            toast.error('Ya exite una modalidad para la Fecha Desde seleccionada.');
            return false;
        }
        if (dataModalidadBulto.fechaHasta != null) {
            const fechaDesde = new Date(dataModalidadBulto.fechaDesde).getTime()
            const fechaHasta = new Date(dataModalidadBulto.fechaHasta).getTime()
            if (fechaHasta < today.getTime()) {
                toast.error('La Fecha Hasta debe ser mayor o igual a la fecha actual.');
                return false;
            }
            if (fechaHasta < fechaDesde) {
                toast.error('La Fecha Hasta debe ser mayor o igual a la Fecha Desde.');
                return false;
            }
        }

        return true;
    }

    const isValidItemKm = () => {
        if (dataModalidadKm.valor <= 0) {
            toast.error('El campo Valor debe ser mayor a cero.');
            return false;
        }
        if (dataModalidadKm.fechaDesde === null) {
            toast.error('Debe ingresar el campo Fecha Desde.');
            return false;
        }
        if (dataFormModel?.rowsModalidades?.find(x => x.modalidad == 'Km' && x.id != dataModalidadKm?.idProveedorMetodoCobroKM && x.fechaDesde == moment(dataModalidadKm.fechaDesde).format("yyyy-MM-DD"))) {
            toast.error('Ya exite una modalidad para la Fecha Desde seleccionada.');
            return false;
        }
        if (dataModalidadKm.fechaHasta != null) {
            const fechaDesde = new Date(dataModalidadKm.fechaDesde).getTime()
            const fechaHasta = new Date(dataModalidadKm.fechaHasta).getTime()
            if (fechaHasta < today.getTime()) {
                toast.error('La Fecha Hasta debe ser mayor o igual a la fecha actual.');
                return false;
            }
            if (fechaHasta < fechaDesde) {
                toast.error('La Fecha Hasta debe ser mayor o igual a la Fecha Desde.');
                return false;
            }
        }

        return true;
    }

    const isValidItemKilo = () => {
        if (dataModalidadKilo.valor <= 0) {
            toast.error('El campo Valor debe ser mayor a cero.');
            return false;
        }
        if (dataModalidadKilo.valorExcedido <= 0) {
            toast.error('El campo Valor Excedido debe ser mayor a cero.');
            return false;
        }
        if (dataModalidadKilo.pesoLimite <= 0) {
            toast.error('El campo Peso Limite debe ser mayor a cero.');
            return false;
        }
        if (dataModalidadKilo.fechaDesde === null) {
            toast.error('Debe ingresar el campo Fecha Desde.');
            return false;
        }
        if (dataFormModel?.rowsModalidades?.find(x => x.modalidad == 'Kilo' && x.id != dataModalidadKilo?.idProveedorMetodoCobroKilo && x.fechaDesde == moment(dataModalidadKilo.fechaDesde).format("yyyy-MM-DD"))) {
            toast.error('Ya exite una modalidad para la Fecha Desde seleccionada.');
            return false;
        }
        if (dataModalidadKilo.fechaHasta != null) {
            const fechaDesde = new Date(dataModalidadKilo.fechaDesde).getTime()
            const fechaHasta = new Date(dataModalidadKilo.fechaHasta).getTime()
            if (fechaHasta < today.getTime()) {
                toast.error('La Fecha Hasta debe ser mayor o igual a la fecha actual.');
                return false;
            }
            if (fechaHasta < fechaDesde) {
                toast.error('La Fecha Hasta debe ser mayor o igual a la Fecha Desde.');
                return false;
            }
        }

        return true;
    }


    return (
        <>

            <CustomDialog
                maxWidth="md"
                fullWidth
                open={open}
                onClose={onClose}
                title={'Modalidad'}
                onCancel={handleCancelar}
                onAccept={() => isNew ? handleAdd() : handleEdit(editRow)}
                acceptText={isNew ? 'Agregar' : 'Guardar'}
            >
                <FormControl>
                    <RadioGroup
                        row
                        aria-labelledby="demo-form-control-label-placement"
                        name="position"
                        defaultValue={1}
                        value={radioSelected}
                        onChange={handleChangeRadio}
                    >
                        <FormControlLabel value={1} control={<Radio disabled={!isNew} />} label="Km" />
                        <FormControlLabel value={2} control={<Radio disabled={!isNew} />} label="Bulto" />
                        <FormControlLabel value={3} control={<Radio disabled={!isNew} />} label="Peso" />
                    </RadioGroup>
                </FormControl>

                <div className=''>
                    {radioSelected == 1 &&
                        <>
                            <Grid
                                container
                                justifyContent={'space-between'}
                                columns={{
                                    xs: 2,
                                    md: 3
                                }}
                                spacing={1}
                                marginTop={1}
                            >
                                <Grid size={{ xs: 1 }}>
                                    <TextInput
                                        label='Valor por Km'
                                        name='valor'
                                        type='number'
                                        value={dataModalidadKm?.valor}
                                        onChange={handleChangeKM}
                                    />
                                </Grid>
                                <Grid size={{ xs: 1 }}>
                                    <DateInput
                                        label="Fecha Desde"
                                        value={dataModalidadKm?.fechaDesde}
                                        onChange={handleChangeFechaDesdeKM}
                                    />
                                </Grid>
                                <Grid size={{ xs: 1 }}>
                                    <DateInput
                                        label="Fecha Hasta"
                                        value={dataModalidadKm?.fechaHasta}
                                        onChange={handleChangeFechaHastaKM}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    }
                    {radioSelected == 2 &&
                        <>
                            <Grid
                                container
                                justifyContent={'space-between'}
                                columns={{
                                    xs: 2,
                                    md: 8
                                }}
                                spacing={1}
                                marginTop={1}
                            >
                                <Grid size={{ xs: 2 }}>
                                    <TextInput
                                        label='Cantidad'
                                        name='cantidad'
                                        type='number'
                                        value={dataModalidadBulto?.cantidad}
                                        onChange={handleChangeBulto}
                                    />
                                </Grid>
                                <Grid size={{ xs: 2 }}>
                                    <TextInput
                                        label='Importe'
                                        name='precio'
                                        type='number'
                                        value={dataModalidadBulto?.precio}
                                        onChange={handleChangeBulto}
                                    />
                                </Grid>
                                <Grid size={{ xs: 2 }}>
                                    <DateInput
                                        label="Fecha Desde"
                                        value={dataModalidadBulto?.fechaDesde}
                                        onChange={handleChangeFechaDesdeBulto}
                                    />
                                </Grid>
                                <Grid size={{ xs: 2 }}>
                                    <DateInput
                                        label="Fecha Hasta"
                                        value={dataModalidadBulto?.fechaHasta}
                                        onChange={handleChangeFechaHastaBulto}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    }
                    {radioSelected == 3 &&
                        <>
                            <Grid
                                container
                                justifyContent={'space-between'}
                                columns={{
                                    xs: 3,
                                    md: 3
                                }}
                                spacing={1}
                                marginTop={1}
                            >
                                <Grid size={{ xs: 1 }}>
                                    <TextInput
                                        label='Valor K'
                                        name='valor'
                                        type='number'
                                        value={dataModalidadKilo?.valor}
                                        onChange={handleChangeKilo}
                                    />
                                </Grid>
                                <Grid size={{ xs: 1 }}>
                                    <TextInput
                                        label='Valor K Excedido'
                                        name='valorExcedido'
                                        type='number'
                                        value={dataModalidadKilo?.valorExcedido}
                                        onChange={handleChangeKilo}
                                    />
                                </Grid>
                                <Grid size={{ xs: 1 }}>
                                    <TextInput
                                        label='Peso Limite'
                                        name='pesoLimite'
                                        type='number'
                                        value={dataModalidadKilo?.pesoLimite}
                                        onChange={handleChangeKilo}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                justifyContent={'space-between'}
                                columns={{
                                    xs: 2,
                                    md: 8
                                }}
                                marginTop={1}
                                spacing={1}
                            >
                                <Grid size={{ xs: 4 }}>
                                    <DateInput
                                        label="Fecha Desde"
                                        value={dataModalidadKilo?.fechaDesde}
                                        onChange={handleChangeFechaDesdeKilo}
                                    />
                                </Grid>
                                <Grid size={{ xs: 4 }}>
                                    <DateInput
                                        label="Fecha Hasta"
                                        value={dataModalidadKilo?.fechaHasta}
                                        onChange={handleChangeFechaHastaKilo}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    }
                </div>
            </CustomDialog>
        </>
    )
}
